import { Resolve } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ClientServiceProfileService } from '@app/shared/services/client-service-profile.service';

export interface BcsRenewalCompositeData {
  hasCarrierNotifications: boolean;
  hasOpenEnrollment: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class BcsRenewalResolver implements Resolve<BcsRenewalCompositeData> {
  private clientServiceProfileService = inject(ClientServiceProfileService);

  public async resolve(): Promise<BcsRenewalCompositeData> {
    const clientServiceProfile = await lastValueFrom(this.clientServiceProfileService.getClientServiceProfile());

    return {
      hasOpenEnrollment: clientServiceProfile[0]?.hasOpenEnrollment || false,
      hasCarrierNotifications: clientServiceProfile[0]?.hasCarrierNotifications || false,
    };
  }
}
